<template>
  <div class="box-shadow">
  <form @submit.stop.prevent ref="form" class="col-md-12">
   	<div class="row">
      <div class="col-sm-6 form-group">
        <label>Type</label>
        <select name="type" class="form-control" v-model="docs_type">
            <option value="">Select Doc Type</option>
            <option value="Address Proof">Address Proof</option>
            <option value="ID Proof">ID Proof</option>
            <option value="ID Proof">Application Form</option>
            <option value="ID Proof">Company Docs</option>
            <option value="ID Proof">KYC Documents</option>
            <option value="ID Proof">Checks</option>
            <option value="Others">Others</option>
          </select>
      </div>  
      <div class="col-sm-6 form-group" v-if="docs_type == 'Others'">
        <label>Other Type</label>
        <input type="text" name="other_type" placeholder="Enter Proof Type Here.." class="form-control">
      </div> 
      <div class="col-sm-6 form-group">
        <label>Status</label>
        <select name="status" class="form-control">
            <option value="0">Pending</option>
            <option value="1">Verified</option>
            <option value="2">Not Verified</option>
          </select>
      </div>  
      <div class="col-sm-6 form-group">
        <label>Description</label>
        <input type="text" name="description" placeholder="Enter Description Here.." class="form-control">
      </div> 
    </div>
    <div class="form-group input-field">
        <label class="active">Docs</label>
        <!-- <div id="input-images" style="padding-top: .5rem;"></div> -->
        <div class="vue_component__upload--image" v-bind:class="{ 'dragover': onDragover }">
            <form v-bind:id="'upload_image_form--' + input_id" enctype="multipart/form-data" style="min-height: inherit;">
                <div v-if="Object.keys(files).length" class="upload_image_form__thumbnails">
                    <div v-for="(value, key) in files" class="upload_image_form__thumbnail"
                        v-on:click="fileClick($event, key)"
                        v-bind:class="{ 'uploaded': value.uploaded, 'bad-size': value.bad_size }">
                        <span v-on:click="fileDelete($event, key)">
                        &#x2716;
                        </span>
                        <img v-bind:src="image[key]" v-bind:class="{ 'show': image[key]}">
                    </div>
                </div>
                <div v-else class="upload-text"><i class="fa fa-upload"></i><span>Drag &amp; Drop files here or click to browse</span></div>
                <input type="file" v-bind:id="'upload_image_form__input--' + input_id" hidden multiple/>
            </form>
        </div>
        <!-- <input type="file" v-bind:id="'upload_image_form__input--' + input_id" hidden multiple/> -->
    </div>
    <input type="hidden" name="id" :value="row.id" class="form-control">
	  <button class="btn btn-lg btn-info" @click="document_upload">Upload</button>
  </form>
  </div>
</template>
<script>
import $ from 'jquery';
import common from '@/assets/js/common.js';
export default {
	name: "UploadDocs",
    mixins: [common],
    props: {
        nested:{},
        row:{},
        input_id: {
            type: String,
            required: false,
            default: "default"
        },
        name: {
            type: String,
            required: false,
            default: 'docs[]'
        },
        disable_upload: {
            type: Boolean,
            required: false,
            default: false
        },
        max_batch: {
            type: Number,
            required: false,
            default: 0
        },
        max_files: {
            type: Number,
            required: false,
            default: 10
        },
        max_filesize: {
            type: Number,
            required: false,
            default: 8000
        },
        resize_enabled: {
            type: Boolean,
            required: false,
            default: false
        },
        resize_max_width: {
            type: Number,
            required: false,
            default: 50
        },
        resize_max_height: {
            type: Number,
            required: false,
            default: 50
        },
    },
    data(){
        return {
            form: null,
            input: null,
            index: 0,
            total: 0,
            files: {},
            image: {},
            batch: {},
            onDragover: false,
            onUploading: false,
            docs_type: "",
            formInput: {
                files : ""
            }
        }
    },
    mounted() {
        this.form = document.getElementById('upload_image_form--' + this.input_id);
        this.input = document.getElementById('upload_image_form__input--' + this.input_id);

        ['drag', 'dragstart', 'dragend',
            'dragover', 'dragenter', 'dragleave', 'drop'].forEach(event => this.form.addEventListener(event, (e) => {
            e.preventDefault();
            e.stopPropagation();
        }));

        ['dragover', 'dragenter']
            .forEach(event => this.form.addEventListener(event, this.dragEnter));

        ['dragleave', 'dragend', 'drop']
            .forEach(event => this.form.addEventListener(event, this.dragLeave));

        ['drop']
            .forEach(event => this.form.addEventListener(event, this.fileDrop));

        ['change']
            .forEach(event => this.input.addEventListener(event, this.fileDrop));

        this.form.addEventListener('click', (e) => {
            this.input.click();
        });
    },
    methods: {
            dragEnter: function (e) {
                e.preventDefault();
                this.onDragover = true;
            },
            dragLeave: function (e) {
                e.preventDefault();
                this.onDragover = false;
            },
            fileDrop: function (e) {
                e.preventDefault();

                let newFiles = e.target.files || e.dataTransfer.files;

                for (let i = 0; i < newFiles.length; i++) {
                    this.$set(this.files, this.index, newFiles[i]);

                    //if (newFiles[i].type.match(/image.*/)) {
                        this.fileInit(this.index);
                        this.fileRead(this.index);

                        this.index++;
                    //};
                }
                e.target.value = '';
            },
            fileInit: function (key) {
                let file = this.files[key];

                this.files[key] = {
                    name: this.files[key].name,
                    file: this.files[key]
                };

                if ((file.size * 0.001) > this.max_filesize) {
                    this.$set(this.files[key], 'bad_size', true);
                }
            },
            fileRead: function (key) {
                let reader = new FileReader();

                reader.addEventListener("load", (e) => {
                    this.$set(this.image, key, reader.result);

                    if (this.resize_enabled) {
                        let imager = new Image();

                        imager.onload = () => {
                            let width = imager.width;
                            let height = imager.height;

                            if (width > this.resize_max_width || height > this.resize_max_height) {
                                if ((height / width) - (this.resize_max_height / this.resize_max_width) > 0) {
                                    width = this.resize_max_height / height * width;
                                    height = this.resize_max_height;
                                } else {
                                    height = this.resize_max_width / width * height;
                                    width = this.resize_max_width;
                                }
                            }

                            let canvas = document.createElement("canvas");
                            canvas.width = width;
                            canvas.height = height;

                            let ctx = canvas.getContext("2d");
                            ctx.drawImage(imager, 0, 0, width, height);

                            let newImageData = canvas.toDataURL("image/png");

                            this.$set(this.image, key, newImageData);

                            //
                            let img = atob(newImageData.split(',')[1]);
                            let img_buffer = [];
                            let i = 0;
                            while (i < img.length) {
                                img_buffer.push(img.charCodeAt(i));
                                i++;
                            }
                            let u8Image = new Uint8Array(img_buffer);

                            this.$set(this.files, key, {
                                name: this.files[key].name,
                                file: new Blob([u8Image], {filename: this.files[key].name})
                            });

                            this.$emit('upload-image-loaded', this.files[key]);
                        };
                        imager.src = reader.result;
                    }
                });

                reader.readAsDataURL(this.files[key].file);
            },
            fileDelete: function (e, key) {
                this.$emit('upload-image-removed', this.files[key]);
                this.$delete(this.files, key);
                this.$delete(this.image, key);
            },
            fileClick: function (e, key) {
                e.preventDefault();
                e.stopPropagation();
                this.$emit('upload-image-clicked', this.files[key]);
            },
        async document_upload(e){
            e.preventDefault();
            e.stopPropagation();
            if(this.index > 10){
                this.$toasted.error("Maximum number of allowable file uploads has been exceeded!",{duration:2000});
                return;
            }
            this.$emit('upload-image-submit', this.files);

            if(!this.disable_upload && !this.onUploading) {
                let formData = new FormData();
                formData.append('id', $(this.$refs.form).find('input[name="id"]')[0].value || "");
                formData.append('status', $(this.$refs.form).find('select[name="status"]')[0].value || "");
                let type = ($(this.$refs.form).find('select[name="type"]')[0].value == 'Others' ? $(this.$refs.form).find('input[name="other_type"]')[0].value : $(this.$refs.form).find('select[name="type"]')[0].value);
                formData.append('type', type);
                $.each(this.files,function(key,file){
                    //console.log(file);
                    formData.append('docs[]', file.file, file.key);
                });
                const {response} = await this.call_axios('edit_customer', 'post', formData);
                if(response.code == 0){
                    this.$toasted.success("Documents uploaded successfully",{duration:500});
                    const { nested } = this
                    nested.$toggle('DisplayRow', true)
                }
            }
        }
    }
}
</script>

<style lang="css">
    .vue_component__upload--image {
        padding: 0px;
        cursor: pointer;
        min-height: 80px;
        border-radius: 5px;
        border: 1px solid gray;
    }

    .vue_component__upload--image.dragover {
    }

    .vue_component__upload--image form > div {
        text-align: center;
    }

    .vue_component__upload--image .upload_image_form__thumbnails {
        margin-bottom: 1em;
    }

    .vue_component__upload--image .upload_image_form__thumbnail {
        border-radius: 2.5px;
        position: relative;
        width: 10%;
        padding: 10% 0 0;
        overflow: hidden;
        margin: 10px;
        display: inline-block;
    }

    .vue_component__upload--image .upload_image_form__thumbnail img {
        position: absolute;
        top: 50%;
        left: 50%;
        min-width: 100%;
        min-height: 100%;
        max-height: 150%;
        opacity: 0;
        transform: translateX(-50%) translateY(-50%);
        transition: 1s opacity;
    }

    .vue_component__upload--image .upload_image_form__thumbnail img.show {
        opacity: 1;
    }

    .vue_component__upload--image .upload_image_form__thumbnail img:hover {
        filter: blur(2px);
    }

    .vue_component__upload--image .upload_image_form__thumbnail.bad-size img {
        filter: grayscale(100%);
    }

    .vue_component__upload--image .upload_image_form__thumbnail.uploaded img {
        opacity: 0.1;
    }

    .vue_component__upload--image .upload_image_form__thumbnail span {
        position: absolute;
        top: 0px;
        left: 0px;
        z-index: 100;
        padding: 0px 1px;
        border-radius: 2px;
        background-color: red;
    }
    .vue_component__upload--image .upload-text {
        position: absolute;
        top: 50%;
        right: 0;
        left: 0;
        bottom: 25%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
    }
</style>